import { createRouter, createWebHistory } from "vue-router";

import Home from "../pages/Home.vue";
import Workspace from "../pages/Workspace.vue";
import ProjectDetail from "../pages/ProjectDetail.vue";
import CreateProject from "../pages/CreateProject.vue";
import ClientsList from "../pages/ClientsList.vue";
import CreateClient from "../pages/CreateClient.vue";
import UserDocuments from "../pages/UserDocuments.vue";

const routes = [
  {
    path: "/",
    redirect: "/home"
  },
  { path: "/home", name: "home", component: Home },
  { path: "/workspace", name: "workspace", component: Workspace },
  {
    path: "/projects/:projectId",
    name: "project-detail",
    component: ProjectDetail
  },
  { path: "/new-project", name: "create-project", component: CreateProject },
  { path: "/clients", name: "clients-list", component: ClientsList },
  { path: "/new-client", name: "create-client", component: CreateClient },
  { path: "/documents", name: "user-documents", component: UserDocuments }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
